import { useModalStore } from "vue-haystack";

import { fetchSignedFileUrlOrThrow } from "@/api/fileSignedUrl";
import FilePreview from "@/domains/files/components/filePreview/FilePreview.vue";
import type { PreviewFile } from "@/store/layoutStore";
import { useLayoutStore } from "@/store/layoutStore";
import { showToastForError } from "@/utils/toast";

export function useFileOpen() {
  const layoutStore = useLayoutStore();
  const modalStore = useModalStore();

  function showFile(fileUrl: string, file: PreviewFile): void {
    layoutStore.setPreviewFile(file);
    if (!layoutStore.bars.previewBar.visible) {
      window.open(fileUrl, "_blank");
    }
  }

  function openPreviewModal(fileUrl: string, fileType: string, fileName: string): void {
    modalStore.push(
      FilePreview,
      {
        fileUrl,
        fileType,
        fileName,
        isOverlay: true,
      },
      {
        close: () => {
          modalStore.remove(modalStore.activeModal.value.id);
        },
      },
      {
        closeOnOverlayClick: true,
      },
    );
  }

  /** Opens the file in the preview overlay with a fresh signed URL; a failed fetch shows a toast instead. */
  async function openPreviewOverlay(file: PreviewFile): Promise<void> {
    try {
      openPreviewModal(await fetchSignedFileUrlOrThrow(file.objectName, file.generation), file.type, file.name);
    } catch (error) {
      showToastForError(error);
    }
  }

  return { openPreviewOverlay, showFile };
}
